export function getDisplayName(input: {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}) {
  const first = input.firstName?.trim() ?? "";
  const last = input.lastName?.trim() ?? "";
  const email = input.email?.trim() ?? "";

  if (first && last) return `${first} ${last}`;
  if (first) return first;
  if (last) return last;
  return email;
}
